export const VALID_FILE_FORMAT = ".csv, .xls, .xlsx";
export const MAX_FILE_SIZE = 5242880; // 5 MB

/**
 * make sure to include both name and code of the bank as the "key" object,
 * and the minimum amount value as the "value" object
 */
export const MIN_TRANSACTION_AMOUNTS = {
  ovo: 10000,
  OVO: 10000,
  dana: 100,
  DANA: 100,
  gopay: 1,
  "Go-Pay": 1,
  GOPAY: 1,
  aladin: 1,
  "Bank Aladin Syariah": 1,
  bca: 1,
  BCA: 1
};

/**
 * const to include companies to follow toggle features for custom max remark
 */
export const MAX_REMARK_TRANSACTION_COMPANY = {
  // GKS
  63152: {
    banks: ["bca", "BCA"],
    limit: 24
  }
};

export const DEFAULT_MAX_REMARK = 18;
export const DEFAULT_MIN_TRANSACTION_AMOUNT = 10000;
export const DEFAULT_MAX_TRANSACTION_AMOUNT = 50000000;
export const BENEFICIARY_EMAIL_LIMIT = 20;

export const DEFAULT_PAGE_LIMIT = 50;
export const DEFAULT_HIGHLIGHT_DELAY = 1200;

export const BUNDLE_TRANSFER_CODE = "BT";
export const BUNDLE_DISBURSEMENT_CODE = "BD";
export const BUNDLE_INTERNATIONAL_TRANSFER_CODE = "BIT";
export const BUNDLE_INTERNATIONAL_DISBURSEMENT_CODE = "BID";

export const MAX_MULTI_BENEFICIARY_SELECTED = 1000;

export const REVIEW_TYPE = {
  upload_csv: 1,
  multi_input: 2
};

export const STATUS_REVIEW = {
  FAILED_LOAD: "-1",
  MIN_AMOUNT: "10",
  MAX_AMOUNT: "11",
  MIN_AMOUNT_OVO: "12",
  MIN_AMOUNT_DANA: "13",
  MIN_AMOUNT_GOPAY: "14",
  MIN_AMOUNT_ALADIN: "15",
  EMAIL_INVALID: "16",
  EMAIL_MAX: "17",
  BANK_IN_SEVERE_DISTURBANCE: "18",
  SUCCESS: "20",
  REMARK_MAX: "21",
  VA_TRANSACTION_RESTRICTIONS: "22",
  INACTIVE_ACCOUNT: "91",
  WRONG_ACCOUNT: "93",
  ACCOUNT_SUSPECTED: "94",
  BLACKLISTED: "95",
  ON_PROCESS_VERIFICATION: "96",
  WAITING_VERIFICATION: "97",
  NAME_INVALID: "98"
};

export const PAYMENT_METHOD = {
  CASH: 1,
  INVOICE_FIXED: 2,
  INVOICE_FLEXIBLE: 3
};

export const OTP_METHOD = {
  PHONE_NUMBER: 1,
  EMAIL: 2,
  EMAIL_NON_OWNER: 3,
  USER_PHONE_NUMBER: 4,
  GAUTH: 5,
  COMPANY_PHONE_NUMBER_WA: 6,
  USER_PHONE_NUMBER_WA: 7
};

export const EMAIL_ERROR_CODES = [
  4315, // maximum total emails
  4316 // wrong email format
];

export const ACCOUNT_ERROR_CODES = [
  4317, // blacklisted account number
  4318, // wrong account number
  4319, // suspected account number
  4324, // invalid bank account
  4325 // unrecognize bank account
];

export const TRANSACTION_STATUS_CODE = {
  NEW_TRANSACTION: 0
};

export const TRANSACTION_METHOD = {
  MULTI_INPUT_RETRY: 5,
  MULTI_INPUT: 14,
  CSV: 15,
  BENEFICIARY: 18,
  RECIPIENT: 16
};

export const LIMIT_EXCEEDED_CODE = 4500;
export const EDD_ONGOING_PROCESS_CODE = 10533;
export const TRIAL_LIMIT_EXCEEDED_CODE = 4501;
export const BANK_OR_COUNTRY_DOWNTIME_ERROR_CODE = 4409;
export const BANK_IN_DISTURBANCE_CODE = 4410;
export const BANK_MAINTENANCE = 4411;

export const TRIAL_LIMIT_ATTRIBUTE = {
  AMOUNT: "amount",
  COUNT: "count",
  PERIODE: "periode"
};

export const UPLOAD_CSV_FORMTYPE = {
  BENEFICIARY: 1,
  SUPER_CSV: 2
};

export const APPROVAL_HISTORY_STATUS = {
  NEW_TRANSACTION: 0,
  SUCCESS: 40,
  FAILED: 50,
  CANCELLED_BY_SYSTEM: 51
};

export const SUMMARY_PAYMENT_METHOD = {
  DEPOSIT: "deposit",
  TRANSFER: "transfer"
};

export const INTERNATIONAL_TRANSACTION_METHOD = {
  BIG_FLIP_LITE_SUPER_EXCEL: 17,
  BIG_FLIP_LITE_MULTI_INPUT: 14
};
